<template>
  <div id="app">
    <router-view />
    <NotificationContainer />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import NotificationContainer from '@/components/NotificationContainer.vue'
import { clearAuthCache } from '@/router'

const onStorageChange = (e: StorageEvent) => {
  if (e.key === 'auth_token' && !e.newValue) {
    clearAuthCache()
  }
}

onMounted(() => {
  window.addEventListener('storage', onStorageChange)
})

onUnmounted(() => {
  window.removeEventListener('storage', onStorageChange)
})
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Kill ALL browser focus rings on click — applies outside Tailwind's layer system */
*:focus {
  outline: none !important;
  outline-width: 0 !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

input:focus,
select:focus,
textarea:focus,
button:focus,
a:focus,
[tabindex]:focus {
  outline: none !important;
  outline-width: 0 !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

/* Restore ring only for keyboard navigation */
*:focus-visible {
  outline: 2px solid rgba(99, 102, 241, 0.5) !important;
  outline-offset: 2px !important;
  box-shadow: none !important;
}
</style>